import React from "react";
import HubspotForm from "../HubspotForm/HubspotForm";
const styles = require("./Newsletter.module.scss");

const Newsletter = React.forwardRef((props, ref) => {
  return (
    <div className={styles.newsletterContainer}>
      <div className={styles.newsletterPattern} ref={ref} />
      <div className={styles.newsletterContent}>
        <div className={`${styles.headerInfo}  ${styles.column}`}>
          <h4>Newsletter</h4>
          <p>
            Subscribe to our exclusive mailing list and get the freshest stories
          </p>
        </div>

        <div className={`${styles.newsletterFormContainer}  ${styles.column}`}>
          <HubspotForm
            selectStyles={{
              option: (provided) => ({
                ...provided,
                color: "black",
              }),
              placeholder: (provided) => ({
                ...provided,
                color: "white",
                opacity: 0.4,
              }),
              singleValue: (provided) => ({
                ...provided,
                color: "white",
              }),
              control: (provided, state) => ({
                ...provided,
                backgroundColor: "transparent",
                border: "1px solid white",
                height: "50px",
                width: "100%",
                color: "white",
                borderRadius: "0",
              }),
            }}
            formId={process.env.GATSBY_NEWSLETTER_FORM_ID}
            mandatoryConsent={true}
            consentError="You have to agree to receive the News and Insights from AMX to Submit"
          />
        </div>
      </div>
    </div>
  );
});

export default Newsletter;
